<template>
    <el-row class="mak-musteri-kontroller">


        <div class="d-flex align-center px-4">
            <v-text-field
                v-model="search"
                clearable
                label="Kontrol musteri ara..."
                type="text"
                prepend-inner-icon="mdi-magnify"
                class="mr-4"
            />

            <el-tag size="default">
                {{tamamlananKontrol}} Tamamlanan / {{toplamKontrol}} Toplam Kontrol
            </el-tag>
        </div>


        <v-overlay absolute :value="loading">
            <v-progress-circular indeterminate size="64"/>
        </v-overlay>

        <v-data-table
            class="mak-musteri-table"
            :headers="headers"
            :items="formatted"
            :search="search"
            item-key="musteri_id"
            :disable-pagination="true"
            hide-default-footer
        >
            <template #item.durum="{ item }">
                <div>
                    <div v-if="item.musteri_durumu">
                        <v-chip
                            color="deep-purple accent-4"
                            text-color="white"
                            small
                        >
                            Demo ({{item.demo_gun_sayisi}})
                        </v-chip>
                    </div>
                    <v-chip
                        v-if="item.id"
                        color="green accent-4"
                        text-color="white"
                        small
                    >
                        Kontrol Edildi
                    </v-chip>
                    <div v-else>
                        <v-chip
                            :color="`${ item.chipColor } accent-4`"
                            text-color="white"
                            small
                        >
                            {{item.durum}}
                        </v-chip>
                    </div>
                </div>
            </template>
            <template #item.baslangic_zamani="{ item }">
                <div class="grey--text">
                   {{ formatDateTime(item.baslangic_zamani) }}
                </div>
            </template>
            <template #item.link="{ item }">
                <a
                    v-if="item.link"
                    :href="item.link"
                    target="_blank"
                    title="Konuma git"
                    style="text-decoration: none"
                >
                    <v-btn small>
                        <v-icon color="green">
                            mdi-map-marker
                        </v-icon>
                    </v-btn>
                </a>
            </template>
            <template #item.actions="{ item }">
                <v-btn
                    v-if="!item.id"
                    small
                    @click="open(item)"
                >
                    <v-icon dark>
                        mdi-check
                    </v-icon>
                </v-btn>
            </template>

        </v-data-table>

        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">

            <v-card class="mak-kontrol-form">
                <v-toolbar
                    dark
                    color="indigo"
                >
                    <v-btn
                        icon
                        dark
                        @click="dialog = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        <b v-if="sirket">{{`${ sirket } - ` }}</b>Makina Kontrolü
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            dark
                            text
                            @click="dialog = false"
                        >
                            Vazgeç
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                    class="mt-8"
                    label-position="top"
                >
                    <el-form-item prop="tahsilat_yapildi" label="Tahsilat Yapıldı mı?">
                        <el-radio-group v-model="form.tahsilat_yapildi">
                            <el-radio-button label="1" name="1">
                                <i class="el-icon-circle-check"/> Yapıldı
                            </el-radio-button>
                            <el-radio-button label="0" name="0">
                                <i class="el-icon-circle-close"/> Yapılmadı
                            </el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                            v-if="form.tahsilat_yapildi === '1'"
                            prop="tahsilat_tutari"
                            label="Tahsilat Tutarı">
                        <el-input
                                v-model="form.tahsilat_tutari"
                                style="width: 100%"
                                placeholder="Tahsilat Tutarı"
                                type="number">
                            <span slot="prepend">₺</span>
                        </el-input>
                    </el-form-item>
                    <el-divider/>
                    <el-form-item prop="dolum_yapildi" label="Dolum Yapıldı mı?">
                        <el-radio-group v-model="form.dolum_yapildi">
                            <el-radio-button label="1" name="11">
                                <i class="el-icon-circle-check"/> Yapıldı
                            </el-radio-button>
                            <el-radio-button label="0" name="00">
                                <i class="el-icon-circle-close"/> Yapılmadı
                            </el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        v-if="form.dolum_yapildi === '1'"
                        prop="dolum_ml"
                        label="Dolum mililitre">
                        <el-input
                            v-model="form.dolum_ml"
                            style="width: 100%"
                            placeholder="Dolum mililitre"
                            type="number">
                            <span slot="prepend">ml</span>
                        </el-input>
                    </el-form-item>

                    <el-divider/>

                    <el-form-item prop="not">
                        <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="Not girin"
                                v-model="form.not"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button
                            icon="el-icon-check"
                            :loading="submitting"
                            :disabled="submitting"
                            @click="save">Kaydet</el-button>
                    </el-form-item>
                </el-form>

            </v-card>
        </v-dialog>
    </el-row>
</template>

<script>
    import moment from 'moment';
    import Formatter from '@/mixins/Formatter.js';

    export default {
        name: 'mak-musteri-kontroller',
        props: {
            year: { type: String, required: true },
            month: { type: String, required: true },
            day: { type: String, required: true },
            toplamKontrol: { type: [Number, String], required: true },
            tamamlananKontrol: { type: [Number, String], required: true },
        },
        mixins: [Formatter],
        data() {
            return {
                search: null,
                dialog: false,
                loading: false,
                submitting: false,
                selected: null,
                list: [],
                form: {
                    musteri_id: null,
                    yil: null,
                    ay: null,
                    not: null,
                    kontrol_zamani: null,
                    tahsilat_yapildi: '1',
                    tahsilat_tutari: null,
                    dolum_yapildi: '1',
                    dolum_ml: null,
                },
                bugunYapilanKontroller: [],
            };
        },
        computed: {
            headers() {
                return [
                    { text: 'Şirket', value: 'sirket_adi' },
                    { text: 'Durum', value: 'durum' },
                    { text: 'Başlangıç zamanı', value: 'baslangic_zamani' },
                    { text: 'Lokasyon', value: 'link', width: 90 },
                    { text: '', value: 'actions', width: 90 },
                ];
            },
            sirket() {
                return this.selected?.sirket_adi;
            },
            date() {
                return moment().format('YYYY-MM-DD')
            },
            rules() {
                const rulez = {
                    not: [{required: true, message: 'Not gerekli', trigger: 'change'}],
                    tahsilat_yapildi: [{required: true, message: 'Tahsilat yapıldı gerekli', trigger: 'change'}],
                    dolum_yapildi: [{required: true, message: 'Dolum yapıldı gerekli', trigger: 'change'}],
                };

                if (this.form.tahsilat_yapildi === '1') {
                    rulez.tahsilat_tutari = [{required: true, message: 'Tahsilat tutarı girilmesi gerekli', trigger: 'change'}];
                }

                if (this.form.dolum_yapildi === '1') {
                    rulez.dolum_ml = [{required: true, message: 'Dolum ml girilmesi gerekli', trigger: 'change'}];
                }

                return rulez;
            },
            params() {
                return {
                    year: this.year,
                    month: this.month,
                    day: this.day,
                };
            },
            formatted() {
                let list = this.list
                    .map((d) => {
                        d.done = !!d.id;

                        if (d.latitude && d.longitude) {
                            d.latitude = parseFloat(d.latitude);
                            d.longitude = parseFloat(d.longitude);
                            d.link = `https://www.google.com/maps/search/?api=1&query=${d.latitude},${d.longitude}`;
                        }

                        d.durum = d.done
                            ? 'Kontrol Edildi'
                            : 'Kontrol eksik';
                        d.chipColor= d.done
                            ? 'green'
                            : 'orange';

                        return d;
                    });

                if (this.search) {
                    list = list.filter((a) => a.sirket_adi.toLowerCase().includes(this.search.toLowerCase()));
                }

                return list.sort((a, b) => a.done - b.done);
            },
        },
        methods: {
            open(row) {
                this.dialog = true;
                this.selected = Object.assign({}, row);
                this.form.tahsilat_tutari = this.selected.makina_tutari;
            },
            handleClose() {
                this.dialog = false;
                this.selected = null;
            },
            fetch() {
                this.loading = true;
                this.$requests
                    .MusteriKontrol.getKontrolGunluk(this.params)
                    .then((data) => {
                        this.list = data;
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            save() {
                if (this.bugunYapilanKontroller.includes(this.selected.musteri_id)) {
                    this.$message.warning('Bu müşteriye bugün tahsilat girilmiş!');
                    return;
                }
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submit();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            submit() {
                const form = Object.assign({}, this.form);
                form.ay = parseInt(this.month) - 1;
                form.yil = parseInt(this.year);
                form.kontrol_zamani = moment().format('YYYY-MM-DD HH:mm:ss');
                form.musteri_id = this.selected.musteri_id;

                if (form.tahsilat_yapildi === '1' && !form.tahsilat_tutari) {
                    this.$message.warning('Lütfen tahsilat tutarı giriniz!');
                    return;
                }

                if (form.tahsilat_yapildi === '0') {
                    delete form.tahsilat_tutari;
                }

                this.submitting = true;
                this.$requests
                    .MusteriKontrol.createMusteriKontrol(form)
                    .then(() => {
                        this.$refs.form.resetFields();
                        this.handleClose();
                        this.fetch();
                        this.$emit('refresh')
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.submitting = false;
                    });
            },
            fetchGununKontrolleri() {
                this.$requests.MusteriKontrol
                    .getMusteriKontrolGun('2021-06-12' || this.date)
                    .then((data) => {
                        console.warn('data', data);
                        this.bugunYapilanKontroller = (data || []).map(d => d.musteri_id);
                    })
                    .catch((error) => {
                        console.error(`error on loading getMusteriKontrolGun`, error);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            this.fetch();
            this.fetchGununKontrolleri();
        },
        watch: {
            dialog() {
                if (!this.dialog) {
                    this.selected = null;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .mak-musteri-kontroller {
        background: transparent;

        ::v-deep .el-table__expanded-cell {
            padding: 0;
        }

        .mak-kontrol-form {
            .el-input  {
                ::v-deep .el-input__inner {
                    width: 100%;
                }
            }
        }
    }
</style>
